import React, { useState } from "react";
import Slider from 'react-slick';
import { Link } from "react-router-dom";
import styled from "styled-components";
import { NextArrow, PrevArrow } from "../Arrows";
import Video from "../Generic/Video";
import SliderImage from '../../public/assets/images/bg/slider.jpg';
import CustomButton from "../CustomButton";

function Banner({ banner, social }) {
  const [isOpen, setIsOpen] = useState(false);
  const [url, setURL] = useState("");

  const banner2Slide = {
    dots: true,
    arrows: true,
    infinite: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1200,
    cssEase: "cubic-bezier(0.4, 0, 0.2, 1)",
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          dots: true
        }
      }
    ]
  };
  // const BackGroudnImage = styled.div`
  //   &:before {
  //     background-image: url(${(props) => props.image});
  //   }
  // `;
  //   const BackGroudnImage = styled.div`
  //   &:before {
  //     background-image:url(${SliderImage});
  //   }
  //  `;
  const handleVideoModal = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <div className="banner-section2 mb-100">
        <ul className="banner-social2 gap-5">
          {social.twitter_url && (
            <li>
              <a
                href={`${social.twitter_url}`}
                target="_blank"
                rel="noreferrer"
              >
                Twitter
              </a>
            </li>
          )}
          {social.facebook_url && (
            <li>
              <a
                href={`${social.facebook_url ? social.facebook_url : ""}`}
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
            </li>
          )}
          {social.instagram_url && (
            <li>
              <a
                href={`${social.instagram_url}`}
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>
            </li>
          )}
          {social.linkedin_url && (
            <li>
              <a
                href={`${social.linkedin_url}`}
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn
              </a>
            </li>
          )}
        </ul>

        <Slider {...banner2Slide}>
          {banner.map((info, index) => (
            <div key={index}>
              {/* <BackGroudnImage className="slider-bg-1" image={info.bg_image}> */}
              <div className="slider-bg-1">
                <div className="slider-bg-image"
                  key={index}
                  style={{
                    backgroundImage: `url(${info.bg_image})`,
                  }}
                >
                </div>
              </div>
              <div className="container">
                <div className="banner3-content">
                  <span className="banner-sub-title">{info.slider_title1}</span>
                  <h1>{info.slider_title2}</h1>
                  <p>{info.slider_title3}</p>
                  {info.video_type === "youtube" ? (
                    <a
                      className="eg-btn btn--primary2 capsule mt-30"
                      onClick={() => {
                        setURL(info.video_url);
                        handleVideoModal();
                      }}
                      href={(e) => e.preventDefault()}
                    >
                      {info.button_title}<CustomButton />
                    </a>
                  ) : info.is_open_self === "1" || info.is_link === "1" ? (
                    <a
                      key={info.button_title}
                      href={info.button_url}
                      target="_blank"
                      rel="noreferrer"
                      className="eg-btn btn--primary2 capsule mt-30"
                    >
                      {info.button_title}<CustomButton />
                    </a>
                  ) : (
                    <Link
                      className="eg-btn btn--primary2 capsule mt-30"
                      to={info.button_url}
                    >
                      {info.button_title}<CustomButton />
                    </Link>
                  )}
                  {info?.agenda_pdf && (
                    <a
                      href={info.agenda_pdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="slider-btn-agenda"
                    >
                      Explore Conference Agenda
                    </a>
                  )}
                </div>
              </div>
              {/* </BackGroudnImage> */}
            </div>
          ))}
        </Slider>
        <div className="banner2-pagination d-flex justify-content-center flex-row align-items-center gap-2" />
      </div>
      {isOpen && <Video handleVideoModal={handleVideoModal} url={url} />}
    </>
  );
}

export default Banner;